import { render, staticRenderFns } from "./LibrarySharePage.vue?vue&type=template&id=6bc5064b&scoped=true"
import script from "./LibrarySharePage.vue?vue&type=script&lang=js"
export * from "./LibrarySharePage.vue?vue&type=script&lang=js"
import style0 from "./LibrarySharePage.vue?vue&type=style&index=0&id=6bc5064b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc5064b",
  null
  
)

export default component.exports